import {Link} from "react-router-dom";
import LongArrow2SVG from "../../icons/LongArrow2SVG";
import React from "react";
import styled from "styled-components";

export const StyledCatalogLink = styled(Link)`
    display: flex;
    align-items: center;
    font-weight: 600;
    color: white;
    font-size: 20px;
    line-height: 140%;
    text-decoration: none;
    gap: 20px;
    width: fit-content;
`;

function CatalogLink() {
    return <StyledCatalogLink className={"catalog-link"} to={"/catalog"}>
        Перейти в каталог <LongArrow2SVG/>
    </StyledCatalogLink>
}

export default CatalogLink;